import { FEATURES_ID } from 'common/constants'
import { handlePermissionByFeatureId } from 'common/helpers'
import isEqual from 'lodash/isEqual'
import { useSelector } from 'react-redux'
import { selectUserPermission } from 'store/session/selectors'

export const useAcceleratedDeprPermission = () => {
  const { data: userPermissions } = useSelector(selectUserPermission, isEqual)
  return handlePermissionByFeatureId(FEATURES_ID.ACCELERATED_DEPRECIATION, userPermissions)
}
